<form [formGroup]="formGroup" (submit)="isFormValid()" fxLayout="column" fxLayoutAlign="center center">

  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="confirmChanges()" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ detail?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_CAMPAIGN' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_CAMPAIGN' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="disableSaveBtn()">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
    <input #inputFile type="file" (change)="cmpMntService.chooseFile($event, formGroup);inputFile.value = ''" hidden="true">
  </mat-toolbar>

  <div class="height-100 width-100">
    <mat-tab-group dynamicHeight="false" class="mat-tab-group-md-width" >
      <!-- Detail Data -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ 'LABEL_DETAILS' | translate}}</span>
        </ng-template>
        
        <div fxLayout="column" class="padding-25" fxFlexFill>
          <!-- code -->
          <div fxLayout>
            <mat-form-field>
              <input
                #code
                matInput
                required
                autocomplete="off" 
                formControlName="code" 
                [placeholder]="'LABEL_CODE' | translate"
                >
            </mat-form-field>
          </div>

          <!-- description -->
          <div fxLayout>
            <mat-form-field>
              <input 
                matInput
                required
                #description 
                autocomplete="off" 
                formControlName="description" 
                [placeholder]="'LABEL_DESCRIPTION' | translate"
                >

              <mat-error *ngIf="formGroup.controls['description'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error>   

              <mat-error *ngIf="formGroup.controls['description'].hasError('maxlength')">
                {{ 'MSG_MAXLENGTH' | translate: {length: '250'} }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- reference_filename -->
          <div fxLayout>
            <mat-form-field>
              <input 
                matInput
                required
                readonly
                autocomplete="off" 
                #reference_filename 
                class="cursor-pointer"
                (click)="inputFile.click()" 
                formControlName="reference_filename" 
                [matTooltip]="formGroup.get('reference_filename').value"
                [placeholder]="'LABEL_REFERENCE_FILENAME' | translate"
                >

                <mat-icon 
                  matSuffix
                  svgIcon="attachment" 
                  class="cursor-pointer"
                  (click)="inputFile.click()" 
                  [matTooltip]="'MSG_CHOOSE_FILE' | translate"
                  *ngIf="formGroup.enabled"
                  >
                </mat-icon>

              <mat-error *ngIf="formGroup.controls['reference_filename'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>
          </div>

          <!-- start_date -->
          <div fxLayout>
            <mat-form-field>
              <input 
                matInput 
                required 
                readonly
                [min]="formGroup.get('code').value ? existingMinDate : minDate" 
                (click)="start_date.open()" 
                [matDatepicker]="start_date" 
                formControlName="start_date" 
                [placeholder]="'LABEL_START_DATE' | translate" 
                >

              <mat-datepicker-toggle matSuffix [for]="start_date"></mat-datepicker-toggle>
              <mat-datepicker (opened)="datepickerOpened()" (closed)="datepickerClosed()" #start_date></mat-datepicker>
              
              <mat-error *ngIf="formGroup.controls['start_date'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error>   
            </mat-form-field>
          </div>

          <!-- end_date -->
          <div fxLayout>
            <mat-form-field>
              <input 
                matInput 
                required 
                readonly
                (click)="end_date.open()" 
                [matDatepicker]="end_date" 
                formControlName="end_date" 
                [min]="formGroup.get('start_date')?.value || minDate" 
                [placeholder]="'LABEL_END_DATE' | translate" 
                >

              <mat-datepicker-toggle matSuffix [for]="end_date"></mat-datepicker-toggle>
              <mat-datepicker #end_date></mat-datepicker>  

              <mat-error *ngIf="formGroup.controls['end_date'].hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>
          </div>

          <!-- reversal_number_of_days -->
          <div fxLayout>
            <mat-form-field>
              <input 
                matInput 
                required 
                formControlName="reversal_number_of_days" 
                [placeholder]="'LABEL_REVERSAL_DAYS' | translate" 
                >

              <mat-error *ngIf="formGroup.get('reversal_number_of_days').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
              
              <mat-error *ngIf="formGroup.get('reversal_number_of_days').hasError('pattern')">
                {{ 'MSG_NUMBERS_ONLY' | translate }}
              </mat-error>   
                          
              <mat-error *ngIf="formGroup.get('reversal_number_of_days').hasError('min')">
                {{ 'MSG_MIN' | translate: {quantity: 1} }}
              </mat-error>
                          
              <mat-error *ngIf="formGroup.get('reversal_number_of_days').hasError('maxlength')">
                {{ 'MSG_MAXLENGTH' | translate: {length: '3'} }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-tab>

      <!-- SMS Responses -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ 'LABEL_CAMPAIGN_SMS_RESPONSES' | translate}}</span>
        </ng-template>
        
        <div fxLayout="column" class="padding-25" fxFlexFill>
          <!-- registration_success -->
          <div fxLayout>
            <mat-form-field>
              <input 
                matInput 
                required 
                formControlName="registration_success" 
                [placeholder]="'LABEL_SMS_REGISTRATION_SUCCESS' | translate" 
                >

              <mat-hint align="end">
                {{ formGroup.get('registration_success').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('registration_success').value?.length) }}
              </mat-hint>

              <mat-error *ngIf="formGroup.get('registration_success').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>
          </div>

          <!-- user_already_registered -->
          <div fxLayout>
            <mat-form-field>
              <input 
                matInput 
                required 
                formControlName="user_already_registered" 
                [placeholder]="'LABEL_SMS_USER_ALREADY_REGISTERED' | translate" 
                >

              <mat-hint align="end">
                {{ formGroup.get('user_already_registered').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('user_already_registered').value?.length) }}
              </mat-hint>

              <mat-error *ngIf="formGroup.get('user_already_registered').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>
          </div>

          <!-- another_user_registered -->
          <div fxLayout>
            <mat-form-field>
              <input 
                matInput 
                required 
                formControlName="another_user_registered" 
                [placeholder]="'LABEL_SMS_ANOTHER_USER_REGISTERED' | translate" 
                >

              <mat-hint align="end">
                {{ formGroup.get('another_user_registered').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('another_user_registered').value?.length) }}
              </mat-hint>

              <mat-error *ngIf="formGroup.get('another_user_registered').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>
          </div>

          <!-- user_maxed_coupon -->
          <div fxLayout>
            <mat-form-field>
              <input 
                matInput 
                required 
                formControlName="user_maxed_coupon" 
                [placeholder]="'LABEL_SMS_USER_MAXED_COUPON' | translate" 
                >

              <mat-hint align="end">
                <!-- {{ formGroup.get('user_maxed_coupon').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('user_maxed_coupon').value?.length) | currency: 'PHP':'symbol-narrow' }} -->
                {{ formGroup.get('user_maxed_coupon').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('user_maxed_coupon').value?.length) }}
              </mat-hint>

              <mat-error *ngIf="formGroup.get('user_maxed_coupon').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</form>